import './topbar.scss';
import { useEffect, useState } from 'react';
import { useLayoutContext } from '../../context/game';

export default function Topbar({title,count}){
	const [context] = useLayoutContext();
	const [correctCount,setCorrectCount] = useState(null);
	useEffect(()=>{
		setCorrectCount(context.hidden.length / 2);
	},[context?.hidden.length])
	const {disclaimer} = window.global_data || {};
	const matchCount = Object.keys(window['game_data'].matches || {}).length
	return(
		<div className="topbar">
			<div className="container">
				<h6 className="topbar-title mb-0">{title || 'Užduotis'}</h6>
				<hr />
				{context?.hasStarted && (<div className="counter">
					
					<svg width="34" height="34" className='me-3' viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17 33.6654C7.79498 33.6654 0.333313 26.2037 0.333313 16.9987C0.333313 7.7937 7.79498 0.332031 17 0.332031C26.205 0.332031 33.6666 7.7937 33.6666 16.9987C33.6666 26.2037 26.205 33.6654 17 33.6654ZM17 30.332C20.5362 30.332 23.9276 28.9273 26.4281 26.4268C28.9286 23.9263 30.3333 20.5349 30.3333 16.9987C30.3333 13.4625 28.9286 10.0711 26.4281 7.57061C23.9276 5.07012 20.5362 3.66536 17 3.66536C13.4638 3.66536 10.0724 5.07012 7.57189 7.57061C5.0714 10.0711 3.66665 13.4625 3.66665 16.9987C3.66665 20.5349 5.0714 23.9263 7.57189 26.4268C10.0724 28.9273 13.4638 30.332 17 30.332ZM15.3383 23.6654L8.26665 16.5937L10.6233 14.237L15.3383 18.952L24.765 9.5237L27.1233 11.8804L15.3383 23.6654Z" fill="#2F8963"/>
					</svg>

					{correctCount}/{matchCount}
				</div>)}
			</div>
			{disclaimer && (
				<div className="topbar-text">
					<div className="container">
						{disclaimer}
					</div>
				</div>
			)}
		</div>
	)
}